import { Layout } from 'antd';
import './App.css';
import AppRoutes from './jsx/layout/nav/AppRoutes';
import FooterBar from './jsx/layout/nav/FooterBar';
import HeaderBar from './jsx/layout/nav/HeaderBar';
import { useEffect } from 'react';
import { initGA, logPageView } from './utils/ga';
import { useLocation } from 'react-router-dom';

const { Header, Content, Footer } = Layout;

function App() {
  const location = useLocation();

  useEffect(() => {
    initGA();
    logPageView();
  }, [location]);


  return (
    <Layout style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Header>
        <HeaderBar />
      </Header>

      <Content style={{
        flex: 1,
        width: '100%'
      }}>
        <div style={{ margin: '16px 0' }}>
          <AppRoutes />
        </div>
      </Content>

      <Footer style={{
        background: '#f0f2f5',
        padding: '40px',
        width: '100%'
      }}>
        <FooterBar />
      </Footer>
    </Layout>
  );
}

export default App;